import { render, staticRenderFns } from "./PDAccessoriesOverview.vue?vue&type=template&id=6385706c&lang=pug"
import script from "./PDAccessoriesOverview.vue?vue&type=script&lang=js"
export * from "./PDAccessoriesOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports